/**
 * SCART Configurator Technical Control Dashboard JS
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-sc-control]');
  if (!root) return;

  var DATA = window.SCART_CONFIGURATOR_DATA;
  var REVIEWS = window.ScartConfiguratorReviewState || { families: {}, cars: {} };
  if (!DATA) {
    console.error('[SCART Control] SCART_CONFIGURATOR_DATA is missing.');
    return;
  }

  var ASSET_URLS = {};
  var assetNode = document.querySelector('#scart-asset-urls');
  if (assetNode) {
    try { ASSET_URLS = JSON.parse(assetNode.textContent); } catch (_) {}
  }

  function resolveAsset(name) {
    if (!name) return '';
    if (ASSET_URLS[name]) return ASSET_URLS[name];
    var base = root.dataset.assetBaseUrl || '/cdn/shop/t/1/assets/';
    return base + name;
  }

  // Get current preview_theme_id if present
  var currentUrlParams = new URLSearchParams(window.location.search);
  var previewThemeId = currentUrlParams.get('preview_theme_id');

  function getTestLink(vehicleId) {
    var url = '/pages/configurateur-test?car=' + encodeURIComponent(vehicleId) + '&review=brieuc';
    if (previewThemeId) {
      url += '&preview_theme_id=' + encodeURIComponent(previewThemeId);
    }
    return url;
  }

  function getEditorLink(vehicleId) {
    var url = '/pages/configurateur-test?car=' + encodeURIComponent(vehicleId) + '&review=brieuc';
    if (previewThemeId) url += '&preview_theme_id=' + encodeURIComponent(previewThemeId);
    return url;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // DOM Elements
  var elKpiFamilies = root.querySelector('[data-sc-kpi="families"]');
  var elKpiPending = root.querySelector('[data-sc-kpi="pending"]');
  var elKpiRejected = root.querySelector('[data-sc-kpi="rejected"]');
  var elKpiValidated = root.querySelector('[data-sc-kpi="validated"]');

  var elFilterSearch = root.querySelector('[data-sc-filter="search"]');
  var elFilterBrand = root.querySelector('[data-sc-filter="brand"]');
  var elFilterFamily = root.querySelector('[data-sc-filter="family"]');
  var elFilterProducts = root.querySelector('[data-sc-filter="products"]');
  var elFilterQuestion = root.querySelector('[data-sc-filter="question"]');
  var elFilterStatus = root.querySelector('[data-sc-filter="status"]');
  var elFilterCount = root.querySelector('[data-sc-filter-count]');
  var elTableBody = root.querySelector('[data-sc-table-body]');

  var activeFilters = {
    search: '',
    brand: 'all',
    family: 'all',
    products: 'all',
    question: 'all',
    status: 'all'
  };

  var expandedRows = new Set();
  var legacyCarIds = {
    'porsche-911-type-g-2-7': 'type-g-27-30',
    'porsche-911-sc-3-0': 'type-g-27-30',
    'porsche-911-carrera-3-2': 'type-g-32',
    'porsche-911-930-turbo': '930',
    'porsche-911-964-carrera': '964-carrera',
    'porsche-911-964-turbo': '964-turbo',
    'porsche-911-993-carrera': '993-carrera',
    'porsche-911-993-turbo': '993-turbo'
  };

  function reviewForFamily(familyId) {
    if (REVIEWS.families && REVIEWS.families[familyId]) return REVIEWS.families[familyId];
    var family = DATA.familyMap && DATA.familyMap[familyId];
    var legacy = family && (family.vehicleIds || []).map(function (vehicleId) {
      var carId = legacyCarIds[vehicleId] || vehicleId;
      return REVIEWS.cars && REVIEWS.cars[carId];
    }).filter(Boolean);
    if (legacy && legacy.length && legacy.every(function (review) { return review.status === 'validated'; })) return legacy[0];
    return { status: 'pending', reason: '', reviewer: '', published: false, locked: false };
  }

  function statusLabel(status) {
    if (status === 'validated') return 'Validé';
    if (status === 'rejected') return 'À revoir';
    return 'À valider';
  }

  function initKPIs() {
    if (elKpiFamilies) elKpiFamilies.textContent = DATA.stats.familiesCount;
    var counts = { pending: 0, rejected: 0, validated: 0 };
    DATA.families.forEach(function (family) {
      var status = reviewForFamily(family.id).status;
      counts[status in counts ? status : 'pending'] += 1;
    });
    if (elKpiPending) elKpiPending.textContent = counts.pending;
    if (elKpiRejected) elKpiRejected.textContent = counts.rejected;
    if (elKpiValidated) elKpiValidated.textContent = counts.validated;
  }

  function populateFilterDropdowns() {
    // Brand dropdown
    if (elFilterBrand) {
      var bHtml = '<option value="all">Toutes les marques (' + DATA.brands.length + ')</option>';
      DATA.brands.forEach(function (b) {
        bHtml += '<option value="' + escapeHtml(b.name) + '">' + escapeHtml(b.name) + ' (' + b.vehiclesCount + ')</option>';
      });
      elFilterBrand.innerHTML = bHtml;
    }

    // Family dropdown
    if (elFilterFamily) {
      var fHtml = '<option value="all">Toutes les familles visuelles (57)</option>';
      DATA.families.forEach(function (f) {
        fHtml += '<option value="' + escapeHtml(f.id) + '">' + escapeHtml(f.name) + ' (' + f.vehicleIds.length + ' v.)</option>';
      });
      elFilterFamily.innerHTML = fHtml;
    }
  }

  function renderTable() {
    if (!elTableBody) return;

    var filtered = DATA.vehicles.filter(function (v) {
      var review = reviewForFamily(v.visualFamilyId);
      // Brand filter
      if (activeFilters.brand !== 'all' && v.brand !== activeFilters.brand) return false;

      // Family filter
      if (activeFilters.family !== 'all' && v.visualFamilyId !== activeFilters.family) return false;

      // Products filter
      if (activeFilters.products === 'with' && v.productCount === 0) return false;
      if (activeFilters.products === 'without' && v.productCount > 0) return false;

      // Question filter
      if (activeFilters.question === 'pse' && !v.hasPseQuestion) return false;
      if (activeFilters.question === 'none' && v.hasPseQuestion) return false;

      if (activeFilters.status !== 'all' && review.status !== activeFilters.status) return false;

      // Text search
      if (activeFilters.search) {
        var query = activeFilters.search.toLowerCase();
        var match = (v.displayName && v.displayName.toLowerCase().indexOf(query) !== -1) ||
          (v.id && v.id.toLowerCase().indexOf(query) !== -1) ||
          (v.visualFamilyId && v.visualFamilyId.toLowerCase().indexOf(query) !== -1) ||
          (v.period && v.period.toLowerCase().indexOf(query) !== -1) ||
          (v.aliases && v.aliases.some(function (a) { return a.toLowerCase().indexOf(query) !== -1; })) ||
          (v.activeProductHandles && v.activeProductHandles.some(function (h) { return h.toLowerCase().indexOf(query) !== -1; }));
        if (!match) return false;
      }

      return true;
    });

    if (elFilterCount) {
      elFilterCount.textContent = filtered.length + ' sur ' + DATA.vehicles.length + ' compatibilités affichées';
    }

    if (!filtered.length) {
      elTableBody.innerHTML = '<tr><td colspan="8" style="text-align:center;padding:3rem;color:var(--sc-ctrl-gray-500)">Aucune compatibilité ne correspond à ces critères de recherche.</td></tr>';
      return;
    }

    var html = '';
    filtered.forEach(function (v) {
      var fam = DATA.familyMap[v.visualFamilyId];
      var review = reviewForFamily(v.visualFamilyId);
      var isShared = fam && fam.isShared;
      var isExpanded = expandedRows.has(v.id);

      // Drawing preview
      var drawingHtml = v.drawingAsset
        ? '<img class="sc-ctrl-thumb-drawing" src="' + resolveAsset(v.drawingAsset) + '" alt="" loading="lazy">'
        : '<span style="color:#94a3b8;font-size:0.75rem">Pas d’asset</span>';

      // Logo preview
      var logoHtml = '';
      if (v.logoAsset) {
        logoHtml = '<img class="sc-ctrl-thumb-logo" src="' + resolveAsset(v.logoAsset) + '" alt="' + escapeHtml(v.logoTitle || '') + '" loading="lazy">' +
          '<div style="font-size:0.75rem;color:var(--sc-ctrl-gray-500);margin-top:2px">' + escapeHtml(v.logoTitle || '') + '</div>';
      } else {
        logoHtml = '<span style="font-size:0.8rem;color:var(--sc-ctrl-gray-600);font-weight:600">Typographique</span>';
      }

      // Shared badge
      var sharedHtml = '';
      if (isShared) {
        var otherCount = fam.vehicleIds.length - 1;
        sharedHtml = '<div style="margin-top:4px"><span class="sc-ctrl-tag sc-ctrl-tag--shared" title="' + escapeHtml(fam.sharedVisualReason || '') + '">Partagé avec ' + otherCount + ' autre' + (otherCount > 1 ? 's' : '') + '</span></div>';
      }
      sharedHtml += v.isProductionReference
        ? '<div style="margin-top:4px"><span class="sc-ctrl-tag">Zones de production</span></div>'
        : '<div style="margin-top:4px"><span class="sc-ctrl-tag sc-ctrl-tag--anomaly">Zones prototype à contrôler</span></div>';

      // Technical question badge
      var qHtml = '';
      if (v.hasPseQuestion) {
        qHtml = '<span class="sc-ctrl-tag sc-ctrl-tag--pse">Kit de suppression PSE</span><div style="font-size:0.7rem;color:var(--sc-ctrl-gray-500);margin-top:2px">Question obligatoire sur la fiche produit</div>';
      } else {
        qHtml = '<span style="color:#94a3b8;font-size:0.8rem">-</span>';
      }

      // Anomalies
      var anomalyHtml = '';
      if (v.anomalies && v.anomalies.length) {
        anomalyHtml = '<div style="margin-top:4px"><span class="sc-ctrl-tag sc-ctrl-tag--anomaly" title="' + escapeHtml(v.anomalies.join(' | ')) + '">⚠️ ' + v.anomalies.length + ' remarque' + (v.anomalies.length > 1 ? 's' : '') + '</span></div>';
      }

      // Products badge & toggle
      var prodsCountHtml = '';
      if (v.productCount > 0) {
        prodsCountHtml = '<div style="display:flex;align-items:center;gap:0.5rem">' +
          '<strong>' + v.productCount + '</strong>' +
          '<button type="button" class="sc-ctrl-btn-expand" data-sc-toggle-prods="' + escapeHtml(v.id) + '">' + (isExpanded ? 'Masquer' : 'Voir') + '</button>' +
          '</div>';
      } else {
        prodsCountHtml = '<span class="sc-ctrl-tag sc-ctrl-tag--zero">0 produit</span>';
      }

      var statusHtml = '<span class="sc-ctrl-status sc-ctrl-status--' + escapeHtml(review.status) + '">' + statusLabel(review.status) + '</span>';
      if (review.status === 'rejected' && review.reason) {
        statusHtml += '<p class="sc-ctrl-status-reason">' + escapeHtml(review.reason) + '</p>';
      }

      html += '<tr>' +
        '<td>' +
        '<div style="font-weight:700;color:var(--sc-ctrl-dark)">' + escapeHtml(v.displayName) + '</div>' +
        '<div style="font-size:0.75rem;color:var(--sc-ctrl-gray-500);font-family:monospace">' + escapeHtml(v.id) + '</div>' +
        anomalyHtml +
        '</td>' +
        '<td>' +
        '<div><strong>' + escapeHtml(v.brand) + '</strong> · ' + escapeHtml(v.model) + '</div>' +
        '<div style="font-size:0.8rem;color:var(--sc-ctrl-gray-500)">' + escapeHtml(v.generationLabel || v.generation) + ' (' + escapeHtml(v.period) + ')</div>' +
        '</td>' +
        '<td>' +
        '<div style="display:flex;align-items:center;gap:0.75rem">' +
        drawingHtml +
        '<div>' +
        '<div style="font-weight:600;font-size:0.85rem">' + escapeHtml(fam ? fam.name : v.visualFamilyId) + '</div>' +
        '<div style="font-size:0.75rem;color:var(--sc-ctrl-gray-500);font-family:monospace">' + escapeHtml(v.visualFamilyId) + '</div>' +
        sharedHtml +
        '</div>' +
        '</div>' +
        '</td>' +
        '<td>' + logoHtml + '</td>' +
        '<td>' + qHtml + '</td>' +
        '<td>' + prodsCountHtml + '</td>' +
        '<td>' + statusHtml + '</td>' +
        '<td>' +
        '<div class="sc-ctrl-actions">' +
        '<a href="' + getTestLink(v.id) + '" class="sc-ctrl-btn-test" target="_blank" rel="noopener">Voir le parcours →</a>' +
        '<a href="' + getEditorLink(v.id) + '" class="sc-ctrl-btn-edit" target="_blank" rel="noopener">Régler / commenter</a>' +
        '</div>' +
        '</td>' +
        '</tr>';

      // Expanded products row
      if (isExpanded && v.activeProducts && v.activeProducts.length) {
        html += '<tr class="sc-ctrl-prods-row"><td colspan="8">' +
          '<div class="sc-ctrl-prods-list">' +
          '<div style="font-weight:700;font-size:0.8rem;text-transform:uppercase;color:var(--sc-ctrl-gray-600)">' + v.productCount + ' références actives pour ce parcours :</div>' +
          v.activeProducts.map(function (p, idx) {
            return '<div class="sc-ctrl-prod-item">' +
              '<span style="color:#94a3b8;font-family:monospace;font-size:0.75rem">' + (idx + 1) + '.</span>' +
              '<span class="sc-ctrl-tag" style="font-size:0.7rem">' + escapeHtml(p.type || 'Échappement') + '</span>' +
              '<a href="/products/' + escapeHtml(p.handle) + '" target="_blank" rel="noopener">' + escapeHtml(p.title) + '</a>' +
              '<span style="color:#94a3b8;font-size:0.75rem;font-family:monospace">(' + escapeHtml(p.handle) + ')</span>' +
              (p.isPseProduct ? '<span class="sc-ctrl-tag sc-ctrl-tag--pse">Requiert PSE</span>' : '') +
              '</div>';
          }).join('') +
          '</div></td></tr>';
      }
    });

    elTableBody.innerHTML = html;
  }

  // Event Listeners
  if (elFilterSearch) {
    elFilterSearch.addEventListener('input', function (e) {
      activeFilters.search = e.target.value.trim();
      renderTable();
    });
  }

  if (elFilterBrand) {
    elFilterBrand.addEventListener('change', function (e) {
      activeFilters.brand = e.target.value;
      renderTable();
    });
  }

  if (elFilterFamily) {
    elFilterFamily.addEventListener('change', function (e) {
      activeFilters.family = e.target.value;
      renderTable();
    });
  }

  if (elFilterProducts) {
    elFilterProducts.addEventListener('change', function (e) {
      activeFilters.products = e.target.value;
      renderTable();
    });
  }

  if (elFilterQuestion) {
    elFilterQuestion.addEventListener('change', function (e) {
      activeFilters.question = e.target.value;
      renderTable();
    });
  }

  if (elFilterStatus) {
    elFilterStatus.addEventListener('change', function (e) {
      activeFilters.status = e.target.value;
      renderTable();
    });
  }

  if (elTableBody) {
    elTableBody.addEventListener('click', function (e) {
      var btnToggle = e.target.closest('[data-sc-toggle-prods]');
      if (btnToggle) {
        var vid = btnToggle.dataset.scToggleProds;
        if (expandedRows.has(vid)) {
          expandedRows.delete(vid);
        } else {
          expandedRows.add(vid);
        }
        renderTable();
      }
    });
  }

  initKPIs();
  populateFilterDropdowns();
  renderTable();
})();
